// Model.js
// -----------------------
// @module Case
define("Katoomi.Shiphawk.Settings.Model", ["Backbone", "Utils"], function (
    Backbone,
    Utils
) {
    "use strict";
    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        url: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/Checkout/SuiteScript2/Settings.Service.ss"
            ),
            true
        ),
    });
});
